import { TextareaAutosize } from "@mui/base";
import { useWatch } from "react-hook-form";

import {
  TranscriptSampleChipMenu,
  RealNoteDisplay,
  TranscriptPreview,
  PreviewSourceToggle,
  PreviewLoadingState,
} from "../ExamplesChipMenu";

const PreviewingAgainstSample = ({
  control,
  handleClearSampleTranscript,
  previewSource,
  setPreviewSource,
  onOpenNotePicker,
  selectedNote,
}) => {
  const formData = useWatch({ control });

  return (
    <div className="flex flex-col gap-sm">
      <PreviewSourceToggle
        previewSource={previewSource}
        setPreviewSource={setPreviewSource}
      />
      {previewSource === "sample" ? (
        <>
          <TranscriptSampleChipMenu
            control={control}
            handleClearSampleTranscript={handleClearSampleTranscript}
          />
          <TranscriptPreview>
            {formData.sampleTranscript}
          </TranscriptPreview>
        </>
      ) : (
        <RealNoteDisplay
          selectedNote={selectedNote}
          onOpenNotePicker={onOpenNotePicker}
        />
      )}
    </div>
  );
};

const PreviewSection = ({
  control,
  loadingPreview,
  handleClearSampleTranscript,
  previewSource,
  setPreviewSource,
  onOpenNotePicker,
  selectedNote,
  previewContent,
}) => {
  const formData = useWatch({ control });

  return (
    <div className="w-full relative">
      {loadingPreview ? (
        <PreviewLoadingState
          previewSource={previewSource}
          selectedNote={selectedNote}
          sampleTranscript={formData.sampleTranscript}
        />
      ) : previewContent ? (
        <div className="relative w-full">
          <p className="text-sm text-secondary my-sm">
            Here's a preview of your template against the note or
            sample you selected. If you wish to try a different note
            or sample, click the <strong>Clear Preview</strong> button
            below.
          </p>
          <TextareaAutosize
            id="preview"
            name="preview"
            data-testid="preview-template-textarea"
            minRows={5}
            value={previewContent}
            readOnly
            className="resize-none appearance-none relative block w-full p-md border-dashed border-2 border-brand bg-secondary placeholder-placeholder text-primary rounded-large z-10 text-xs md:text-sm h-8"
          />
        </div>
      ) : (
        <div className="relative w-full">
          <PreviewingAgainstSample
            control={control}
            handleClearSampleTranscript={handleClearSampleTranscript}
            previewSource={previewSource}
            setPreviewSource={setPreviewSource}
            onOpenNotePicker={onOpenNotePicker}
            selectedNote={selectedNote}
          />
        </div>
      )}
    </div>
  );
};

export default PreviewSection;
